<template>
  <div class="pipeline-column-container">
    <!-- Header -->
    <div class="pipeline-column-header">
      <div class="level is-mobile">
        <div class="level-left">
          <div class="level-item">

            <b-tooltip
              :label="status.label"
              position="is-bottom"
            >
              <p class="active--status_name block mb-25 is-5">
                {{ status.label | truncate(24) }}
              </p>
            </b-tooltip>
          </div>
        </div>

        <div class="level-right">
          <p class="active--record_count red">{{ recordCounts.red }}</p>
          <p class="active--record_count yellow">{{ recordCounts.yellow }}</p>
          <p class="active--record_count green">{{ recordCounts.green }}</p>
        </div>
      </div>
    </div>

    <!-- Body -->
    <active-column-body class="pipeline-column-body" :status="status"></active-column-body>
  </div>
</template>

<script>
import ActiveColumnBody from "./ActiveColumnBody";
import dates from "../../../../../services/dates";

export default {
  name: "ActiveColumn",
  components: {
    ActiveColumnBody
  },
  props: {
    status: Object,
  },
  computed: {
    recordCounts() {
      let red = 0;
      let yellow = 0;
      let green = 0;

      const records = this.$store.getters['activeState/recordsByStatusId'](this.status.id);
      let nowDate = dates.getNowISO()

      records.forEach((record) => {
        let nextTaskDueAt = null;
        if (record.nextTask) {
          nextTaskDueAt = record.nextTask.due_at;
        }

        if(dates.isBefore(nextTaskDueAt, nowDate)) {
          red += 1;
        } else if (dates.isBefore(nextTaskDueAt, dates.addDay(nowDate))) {
          yellow += 1;
        } else {
          green += 1;
        }
      });

      return {
        "red": red,
        "yellow": yellow,
        "green": green,
      };
    }
  },
};
</script>

<style lang="scss" scoped>
@import "../../../../../styles/variables/variables";

.pipeline-column-container {
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: auto 1fr;
  grid-template-areas: "header" "main";
}

.pipeline-column-header {
  grid-area: header;
  padding-bottom: 0.25rem;
  border-bottom: 2px solid $border;
}

.pipeline-column-body {
  grid-area: main;
  overflow-y: scroll;
  padding: 0.5rem 8px 6px;
  @include scrollbar();
}

.active {

  &--status_name {
    color: $text-muted;
  }

  &--record_count {
    margin-right: 6px;
    font-size: 0.75rem;
    font-weight: bold;

    &.red {
      color: $red;
    }

    &.yellow {
      color: $amber;
    }

    &.green {
      color: $green;
    }
  }
}

:deep.b-tooltip.is-bottom .tooltip-content {
  left: 66%;
}
</style>
